/**
 * An enumeration of all possible event keys the client script can send to the
 * backend.
 */
export const STREAM_EVENT_KEYS = Object.freeze({
    IDENTIFY_USER: 'identify_user',
    AUTOTAG_RECORDING: 'autotag_recording',
    TAG_RECORDING: 'tag_recording',
    HEATMAP_HELO: 'heatmap_helo',
    RECORDING_HELO: 'recording_helo',
    REPORT_USER_ID: 'report_user_id',
    MUTATION: 'mutation',
    MOUSE_CLICK: 'mouse_click',
    INPUT_CHOICE_CHANGE: 'input_choice_change',
    KEY_PRESS: 'key_press',
    MOUSE_MOVE: 'mouse_move',
    RELATIVE_MOUSE_MOVE: 'relative_mouse_move',
    CLIPBOARD: 'clipboard',
    PAGE_VISIBILITY: 'page_visibility',
    SCROLL_REACH: 'scroll_reach',
    SCROLL: 'scroll',
    SELECT_CHANGE: 'select_change',
    VIEWPORT_RESIZE: 'viewport_resize',
    SCRIPT_PERFORMANCE: 'script_performance',
    REPORT_CONTENT: 'report_content',
    INSERTED_RULE: 'inserted_rule',
    DELETED_RULE: 'deleted_rule'
});
